import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    showReleaseDetails: false,
    releaseNoteTitle: '',
    clickedReleaseItem: '',
    reset: false,
    pageReload: true,
    releaseNotesAccordionActive: []
};

const staticPagesSlice = createSlice({
    name: "staicPages",
    initialState,
    reducers: {
        setShowReleaseDetails: (state, action) => {
            state.showReleaseDetails = action.payload;
        },
        setReleaseNoteTitle: (state, action) => {
            state.releaseNoteTitle = decodeURIComponent(action.payload.trim());
        },
        setClickedReleaseItem: (state, action) => {
            state.clickedReleaseItem = decodeURIComponent(action.payload?.trim());
        },
        resetAllReleaseItems: (state) => {
            state.showReleaseDetails = false;
            state.releaseNoteTitle = '';
            state.clickedReleaseItem = '';
            state.reset = true
        },
        setResetAllReleaseItems: (state) => {
            state.reset = false
        },
        resetPageReload: (state) => {
            state.pageReload = false
        },
        setReleaseNotesAccordionActive: (state, action) => {
            state.releaseNotesAccordionActive = action.payload;
        }
    },
});

export const { setReleaseNotesAccordionActive,  resetPageReload, setShowReleaseDetails, setReleaseNoteTitle, setClickedReleaseItem, resetAllReleaseItems, setResetAllReleaseItems } = staticPagesSlice.actions;

export default staticPagesSlice.reducer;